import { useMeta } from '@nuxtjs/composition-api';
import { getFeedMetaTags } from './feedUtils';
import { mergeHeadItems } from '~/modules/common/utils/helpers';
import {
  generateNewsMediaOrganizationSchema,
  generateSiteNavigationElementSchema,
  generateWebsiteSchema,
  getSchemaHead,
} from '~/modules/common/utils/schemaUtils';

export function useFeedMeta() {
  useMeta(() => {
    const websiteSchema = generateWebsiteSchema();
    const newsMediaOrganization = generateNewsMediaOrganizationSchema();
    const siteNavigationElementSchema = generateSiteNavigationElementSchema();
    return mergeHeadItems(
      // feed meta tags
      getFeedMetaTags(),
      // schema.org
      getSchemaHead(websiteSchema),
      getSchemaHead(newsMediaOrganization),
      getSchemaHead(siteNavigationElementSchema)
    );
  });
}
